export default __webpack_public_path__ + "static/media/Aura-Egg__66.556d395d.png";